'use client';

import { ComponentPropsWithoutRef, type ReactNode } from 'react';
import { cn } from '../../lib/utils';
import { Text } from '../typography/text';
import { useRadioChoiceCardFrameContext } from './radio-choice-card-context';

export type RadioChoiceCardTitleProps = ComponentPropsWithoutRef<'span'> & {
  children?: ReactNode;
};

export const RadioChoiceCardTitle = ({ className, ...props }: RadioChoiceCardTitleProps) => {
  const { truncate } = useRadioChoiceCardFrameContext();

  return (
    <Text
      as="span"
      variant="typo-sm"
      data-slot="radio-choice-card-title"
      className={cn(
        'block min-w-0 text-text-primary group-data-[disabled]:text-text-disabled',
        truncate && 'truncate',
        className,
      )}
      {...props}
    />
  );
};

export type RadioChoiceCardDescriptionProps = ComponentPropsWithoutRef<'span'> & {
  children?: ReactNode;
};

export const RadioChoiceCardDescription = ({
  className,
  ...props
}: RadioChoiceCardDescriptionProps) => {
  const { truncate } = useRadioChoiceCardFrameContext();

  return (
    <Text
      as="span"
      variant="typo-sm"
      data-slot="radio-choice-card-description"
      className={cn(
        'block min-w-0 text-text-secondary group-data-[disabled]:text-text-disabled',
        truncate && 'truncate',
        className,
      )}
      {...props}
    />
  );
};
